import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const handoffsPlugin = createPlugin({
  id: 'handoffs',
  routes: {
    root: rootRouteRef,
  },
});

export const HandoffsPage = handoffsPlugin.provide(
  createRoutableExtension({
    name: 'HandoffsPage',
    component: () =>
      import('./components/HandoffsPage').then(m => m.HandoffsPage),
    mountPoint: rootRouteRef,
  }),
);
